import { useRef } from 'react';
/**
 * A hook used to create an array of references
 *
 * @returns an object containing an array of references and a function to set a reference value
 */
export function useRefArray() {
  const ref = useRef(undefined);
  if (ref.current === undefined) {
    const refs = [];
    const setRefs = [];
    ref.current = {
      refs,
      createSetRef(index) {
        let setRef = setRefs[index];
        if (setRef === undefined) {
          setRef = function (next) {
            refs[index] = next;
          };
          setRefs[index] = setRef;
        }
        return setRef;
      }
    };
  }
  return ref.current;
}
//# sourceMappingURL=useRefArray.js.map